import { render, staticRenderFns } from "./SidebarSharePlugin.vue?vue&type=template&id=1efbebe9&scoped=true"
import script from "./SidebarSharePlugin.vue?vue&type=script&lang=js"
export * from "./SidebarSharePlugin.vue?vue&type=script&lang=js"
import style0 from "./SidebarSharePlugin.vue?vue&type=style&index=0&id=1efbebe9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efbebe9",
  null
  
)

export default component.exports